"use client";

import { ReactNode, useCallback, useEffect, useState } from "react";
import { trackTickerStripDisplayBannerIconClick } from "./unifiedCt";

interface OpenDematFloatBannerVisibilityClientProps {
  children: ReactNode;
  floatingBannerMainText?: string;
  brokerageMainText?: string;
  loadOnPageLoad?: boolean;
}

const OpenDematFloatBannerVisibilityClient = ({
  children,
  floatingBannerMainText,
  brokerageMainText,
  loadOnPageLoad = false,
}: OpenDematFloatBannerVisibilityClientProps) => {
  const [showBanner, setShowBanner] = useState(loadOnPageLoad);
  const [manuallyClosed, setManuallyClosed] = useState(false);

  const trackTickerStripClose = useCallback(() => {
    void trackTickerStripDisplayBannerIconClick(
      floatingBannerMainText,
      brokerageMainText ?? "BROKERAGE",
    );
  }, [brokerageMainText, floatingBannerMainText]);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (loadOnPageLoad) return;

    let ticking = false;

    const updateBannerVisibility = () => {
      if (manuallyClosed) return;

      const shouldShow = window.scrollY > 100;
      setShowBanner((prev) => {
        if (prev !== shouldShow) return shouldShow;
        return prev;
      });

      ticking = false;
    };

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateBannerVisibility);
        ticking = true;
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    updateBannerVisibility();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [manuallyClosed, loadOnPageLoad]);

  const handleClose = () => {
    setShowBanner(false);
    setManuallyClosed(true);
    trackTickerStripClose();
  };

  if (!showBanner) return null;

  return (
    <>
      {children}
      <button
        className="bg-lgray-200 fixed bottom-0 right-0 z-[100000] hidden min-h-[73px] w-[73px] cursor-pointer items-center justify-center md:flex"
        onClick={handleClose}
        aria-label="Close banner"
      >
        <i className="icomoon text-[20px] before:content-['\e914']"></i>
      </button>
    </>
  );
};

export default OpenDematFloatBannerVisibilityClient;
